/**
 * Locate a tracked-legislator row in a workspace tracking list response.
 * API rows often expose the legislator as `id` (not always legislator_id).
 */
export function findTrackedLegislator(
  items: unknown,
  legislatorId: string | undefined | null,
): Record<string, unknown> | null {
  if (legislatorId == null || legislatorId === '') return null;

  const arr: unknown[] = Array.isArray(items)
    ? items
    : items && typeof items === 'object' && Array.isArray((items as { legislators?: unknown }).legislators)
      ? ((items as { legislators: unknown[] }).legislators)
      : [];

  const match = arr.find((row) => {
    if (!row || typeof row !== 'object') return false;
    const r = row as Record<string, unknown>;
    const rowId = r.id ?? r.legislator_id ?? r.legislatorId;
    return String(rowId) === String(legislatorId);
  });

  return match && typeof match === 'object'
    ? (match as Record<string, unknown>)
    : null;
}

/** POST /workspace-legislator-tracking body (array workspaceIds, not singular). */
export function buildLegislatorTrackBody(
  legislatorId: string,
  workspaceId: string,
): { legislatorId: string; workspaceIds: string[] } {
  return { legislatorId, workspaceIds: [workspaceId] };
}

/** DELETE /workspace-legislator-tracking body (axios `{ data }`). */
export function buildLegislatorUntrackBody(
  legislatorId: string,
  workspaceId: string,
): { legislatorId: string; workspaceIds: string[] } {
  return { legislatorId, workspaceIds: [workspaceId] };
}
